import './ActionableIcon.css';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { generateClassName, shouldRenderComponent } from './helpers';
import { useLoginContext } from '../../App';
import B2BDialog from './B2BDialog';
import { Cancel, Check } from '@mui/icons-material';
import useB2BTranslation from './hooks/useB2BTranslation';

const ActionableIcon = ({ id, icon: Icon, confirm = false, onClick, onConfirm, confirmDialog = null, tooltip, className = null, rolesAllowed = [], b2bProducts = [] }) => {

    const { t } = useB2BTranslation('b2b-common');
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

    const { loginData } = useLoginContext();
    if (!shouldRenderComponent(loginData, rolesAllowed, b2bProducts)) {
        return null;
    }

    const handleClick = (event) => {
        event.stopPropagation();
        if (confirm) {
            setIsConfirmationOpen(true);
        } else {
            onClick && onClick(id);
        }
    };

    const handleConfirmation = (event) => {
        event.stopPropagation();
        setIsConfirmationOpen(false);
        onConfirm && onConfirm(id);
    };

    const handleCancel = (event) => {
        event.stopPropagation();
        setIsConfirmationOpen(false);
    };

    return (
        <>
            <IconButton id={id} className={generateClassName('b2b-actionable-icon', '-container', className)} onClick={handleClick} title={tooltip}>
                <Icon />
            </IconButton>
            <B2BDialog open={isConfirmationOpen} title={t('Confirmation Request')}
                onClose={() => setIsConfirmationOpen(false)}
                buttons={[
                    {
                        label: t('Confirm'),
                        onClick: handleConfirmation,
                        icon: <Check />
                    },
                    {
                        label: t('Cancel'),
                        onClick: handleCancel,
                        icon: <Cancel />
                    },
                ]}
            >
                <p>{confirmDialog ? confirmDialog : t('Are you sure you want to proceed with this action?')}</p>
            </B2BDialog>
        </>
    );
};

ActionableIcon.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.elementType.isRequired,
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
};

ActionableIcon.defaultProps = {
    tooltip: '',
};

export default ActionableIcon;